export default {
  /**
   * @param dates
   * @param filters
   * @param payment
   * @returns Object
   */
  buildSpecificationOfPaymentRequestBody(dates, filters, payment) {
    return {
      arrival: {
        from: dates.arrivalFromDate,
        to: dates.arrivalToDate,
      },
      paidAt: {
        from: dates.paidDateFromDate,
        to: dates.paidDateToDate,
      },
      domains: filters.selectedDomains,
      suppliers: filters.selectedSuppliers,
      brands: filters.selectedBrands,
      paymentIds: [payment],
    };
  },
  /**
   * @param dates
   * @param filters
   * @returns Object
   */
  buildSupplierPaymentRequestBody(dates, filters) {
    return {
      arrival: {
        from: dates.arrivalFromDate,
        to: dates.arrivalToDate,
      },
      paidAt: {
        from: dates.paidDateFromDate,
        to: dates.paidDateToDate,
      },
      domains: filters.selectedDomains,
      suppliers: filters.selectedSuppliers,
      brands: filters.selectedBrands,
      productTypes: filters.selectedProductTypes,
    };
  },

  /**
   * @param dates
   * @param filters
   * @param supplier
   * @returns Object
   */
  buildSpecificationRequest(dates, filters, supplier) {
    return {
      arrival: {
        from: dates.arrivalFromDate,
        to: dates.arrivalToDate,
      },
      paidAt: {
        from: dates.paidDateFromDate,
        to: dates.paidDateToDate,
      },
      domains: filters.selectedDomains,
      suppliers: [supplier],
      brands: filters.selectedBrands,
    };
  },
};



// WEBPACK FOOTER //
// ./src/services/payment-service/supplier-payment-service-mappers.js